import { render, staticRenderFns } from "./KpiSatisfaccion.vue?vue&type=template&id=0a4e0868&"
import script from "./KpiSatisfaccion.vue?vue&type=script&lang=js&"
export * from "./KpiSatisfaccion.vue?vue&type=script&lang=js&"
import style0 from "./KpiSatisfaccion.vue?vue&type=style&index=0&id=0a4e0868&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports